
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import TransactionFilterMenu from '@/components/dashboard/TransactionFilterMenu';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

interface TransactionFilterBarProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  filters: Record<string, string | null>;
  onFilterChange: (filterType: string, value: string | null) => void;
  onClearFilters: () => void;
  onRefresh?: () => void;
  isRefreshing?: boolean;
}

const TransactionFilterBar: React.FC<TransactionFilterBarProps> = ({
  activeTab,
  onTabChange,
  filters,
  onFilterChange,
  onClearFilters,
  onRefresh,
  isRefreshing = false
}) => {
  // Add debug log to track tab changes
  const handleTabChange = (value: string) => {
    console.log('[TransactionFilterBar] Tab changed to:', value);
    onTabChange(value);
  };

  return (
    <div className="flex flex-col space-y-4 md:flex-row md:justify-between md:space-y-0">
      <Tabs defaultValue="all" value={activeTab} onValueChange={handleTabChange}>
        <TabsList>
          <TabsTrigger value="all">All Transactions</TabsTrigger>
          <TabsTrigger value="succeeded">Successful</TabsTrigger>
          <TabsTrigger value="pending">Pending</TabsTrigger>
          <TabsTrigger value="failed">Failed</TabsTrigger>
        </TabsList>
      </Tabs>
      
      <div className="flex items-center gap-2">
        {onRefresh && (
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onRefresh}
            disabled={isRefreshing}
            className="flex items-center gap-1 rounded-md border-none bg-primary text-white hover:bg-blue-500"
          >
            <RefreshCw className={`h-4 w-4 ${isRefreshing ? 'animate-spin' : ''}`} />
            Refresh
          </Button>
        )}
        <TransactionFilterMenu 
          onFilterChange={onFilterChange}
          activeFilters={filters}
          onClearFilters={onClearFilters}
        />
      </div>
    </div>
  );
};

export default TransactionFilterBar;
